import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import CustomerListComponent from '@app/components/shared/customer-list.component';
import * as models from '@app/models';
import { Grid } from '@material-ui/core';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

class AdminCustomerComponent extends React.Component<models.IAdminCustomerProps, any> {
	constructor(props: models.IAdminCustomerProps) {
		super(props);
	}

	public render() {
		return (
			<React.Fragment>
				<Grid container={true} direction='column' spacing={2}>
					<Grid item={true} xl={12} lg={12} xs={12} sm={12}>
						<CustomerListComponent intl={this.props.intl} />
					</Grid>
				</Grid>
			</React.Fragment>
		);
	}
}
export default withRouter(withAxiosCancellation(injectIntl(AdminCustomerComponent)));



// WEBPACK FOOTER //
// ./src/components/admin/customer/admin-customer.component.tsx